/**
 * Imaging findings list with modality badges.
 */
import { FC } from 'react'
import type { ImagingFinding } from '../types'
import { InlineMd } from './InlineMd'

export const ImagingFindings: FC<{ findings: ImagingFinding[] }> = ({ findings }) => (
  <div className="space-y-1.5">
    {findings.map((f, i) => (
      <div key={i} className="bg-muted border border-border rounded-lg p-2.5">
        <span className="text-[10px] font-semibold text-primary uppercase tracking-wider">{f.modality}</span>
        <p className="text-xs text-muted-foreground leading-relaxed mt-0.5"><InlineMd>{f.finding}</InlineMd></p>
      </div>
    ))}
  </div>
)
